import { WithChildrenProps } from '@app/types/generalTypes';
import React from 'react';
import * as S from './MainHeader.styles';

export const MainHeader: React.FC<WithChildrenProps> = ({ children }) => {
  return <S.Header>{children}</S.Header>;
};
